import type { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";

export type StatusTone = "muted" | "success" | "danger";

export function StatusCard({
	tone,
	icon,
	title,
	description,
	action,
}: {
	tone: StatusTone;
	icon: ReactNode;
	title: string;
	description: string;
	action?: ReactNode;
}) {
	return (
		<Card>
			<CardContent className="status-card">
				<span className="status-card__icon" data-tone={tone}>
					{icon}
				</span>
				<div className="status-card__heading">
					<h1 className="status-card__title">{title}</h1>
					<p className="status-card__description">{description}</p>
				</div>
				{action}
			</CardContent>
		</Card>
	);
}
